
import { Component, Vue } from 'vue-property-decorator';
import BasePagina from '@/components/base/BasePagina.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BasePesquisa from '@/components/base/BasePesquisa.vue';
import BaseLista from '@/components/base/BaseLista.vue';
import BaseCampos from '@/components/base/BaseCampos.vue';
// Services
import RegraService from '@/services/regra.service';
// Models
import { RegraInterface } from '@/shared/models/regra/regra.interface';
import { RegraFilter } from '@/shared/models/regra/regra.filter';
import { TipoLancamentoEnum } from '@/shared/enums/tipo-lancamento.enum';
import { BaseDialogInterface } from '@/shared/models/base/dialog.interface';// UTILS
import Rules from '@/shared/utils/rules.util';

@Component({
  components: {
    BasePagina,
    BaseDialog,
    BasePesquisa,
    BaseLista,
    BaseCampos,
  },
})
export default class Regras extends Vue {
  public rules = Rules;

  public labelBotaoNovo = 'Nova Regra Débito';

  public editedItem = {} as RegraInterface;

  public filtro = {} as RegraFilter;

  // Dialog
  public dialogInterface = {
    formTitle: '',
    dialog: false,
    textBotaoPrimario: 'Salvar',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalCriarEditarExcluir,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

    public readonlyCamposDialog = false;

    public readonlyCodigoCamposDialog = false;

    // Campos do Dialog

  public colapses = [{ titulo: 'Filtragem', nomeSlot: 'pesquisa' },
    { titulo: 'Regra de Crédito', nomeSlot: 'listaRegrasCredito' },
    { titulo: 'Lista de Regras de Débito', nomeSlot: 'listaRegrasDebito' }];

  public listaRegrasCredito: Array<RegraInterface> = [];

  public listaRegrasDebito: Array<RegraInterface> = [];

  public listaCamposPesquisa = [
    {
      text: 'Código', type: 'textField', value: 'codigo', cols: '6',
    },
    {
      text: 'Descrição', type: 'textField', value: 'descricao', cols: '6',
    },
  ];

  public headersRegrasCredito: Array<Record<string, any>> = [
    {
      text: 'Descrição', value: 'descricao', align: 'center', sortable: false,
    },
    {
      text: 'Fator de Conversão', value: 'fator', align: 'center', sortable: false,
    },
    {
      text: 'Ação', value: 'acao', align: 'center', sortable: false,
    },
  ];

  public headersRegrasDebito: Array<Record<string, any>> = [
    {
      text: 'Código', value: 'codigo', align: 'center', sortable: false,
    },
    {
      text: 'Descrição', value: 'descricao', align: 'center', sortable: false,
    },
    {
      text: 'Fator de Conversão', value: 'fator', align: 'center', sortable: false,
    },
    // {
    //   text: 'PVD\'s Vinculados', value: 'pvdVinculados', align: 'center', sortable: false,
    // },
    {
      text: 'Ação', value: 'acao', align: 'center', sortable: false, width: '80px',
    },
  ];

  public listaAcoesRegrasCredito = [
    { tooltip: 'Editar', icon: 'mdi-square-edit-outline', function: this.abrirEditar },
  ];

  public listaAcoesRegrasDebito = [
    { tooltip: 'Editar', icon: 'mdi-square-edit-outline', function: this.abrirEditar },
    { tooltip: 'Excluir', icon: 'mdi-delete-outline', function: this.abrirExcluir },
  ];

  public listaCamposCriarEditarExcluir = [
    {
      text: 'Descrição', type: 'textField', value: 'descricao', cols: '12', counter: '100', maxlength: '100', required: true, rules: [this.rules.campo_obrigatorio],
    },
    {
      text: 'Fator de conversão de pontos', type: 'numberField', value: 'fator', step: '0.01', cols: '12', required: true, rules: [this.rules.campo_obrigatorio, this.rules.somente_numeros_diferente_zero, this.rules.somente_numeros_positivos, this.rules.numero_positivo_com_duas_casas_decimais], clearable: true,
    },
  ];

  // Pesquisar
  async pesquisar(filtro: RegraFilter) {
    const listaRegras: Array<RegraInterface> = await new RegraService().buscarPorFiltro(filtro);
    this.separaListaRegras(listaRegras);
  }

  async buscarTodas() {
    const listaRegras: Array<RegraInterface> = await new RegraService().buscarTodas();
    this.separaListaRegras(listaRegras);
  }

  // Dialog de Editar
  private async abrirEditar(item: any) {
    this.dialogInterface.formTitle = 'Editar Produto';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.readonlyCamposDialog = false;
    this.readonlyCodigoCamposDialog = true;
    this.dialogInterface.funcaoPrimaria = this.atualizar;
    this.editedItem = await new RegraService().buscarPorCodigo(item.codigo);
    if (this.editedItem !== undefined) {
      this.dialogInterface.dialog = true;
    }
  }

  // Dialog de Criar
  private abrirCriar() {
    this.dialogInterface.formTitle = 'Nova Regra de Débito';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.readonlyCamposDialog = false;
    this.readonlyCodigoCamposDialog = false;
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.dialogInterface.funcaoPrimaria = this.salvar;
    this.editedItem = {} as RegraInterface;
    this.dialogInterface.dialog = true;
  }

  // Dialog de Excluir
  private async abrirExcluir(item: any) {
    this.dialogInterface.formTitle = 'Excluir Cupom';
    this.dialogInterface.textBotaoPrimario = 'Excluir';
    this.readonlyCamposDialog = true;
    this.readonlyCodigoCamposDialog = true;
    this.dialogInterface.colorBotaoPrimario = 'warning';
    this.dialogInterface.funcaoPrimaria = this.excluir;
    this.editedItem = await new RegraService().buscarPorCodigo(item.codigo);
    if (this.editedItem !== undefined) {
      this.dialogInterface.dialog = true;
    }
  }

  async salvar() {
    this.editedItem.tipoLancamento = TipoLancamentoEnum.DEBITO;
    new RegraService().salvar(this.editedItem)
      .then(() => {
        this.pesquisar(this.filtro);
      });
  }

  async atualizar() {
    new RegraService().atualizar(this.editedItem)
      .then(() => {
        this.pesquisar(this.filtro);
      });
  }

  async excluir() {
    new RegraService().excluir(this.editedItem)
      .then(() => {
        this.pesquisar(this.filtro);
      });
  }

  private fecharModalCriarEditarExcluir() {
    this.dialogInterface.dialog = false;
    this.editedItem = {} as RegraInterface;
  }

  private separaListaRegras(listaRegras: Array<RegraInterface>) {
    this.listaRegrasCredito = listaRegras.filter((regra: RegraInterface) => regra.tipoLancamento === TipoLancamentoEnum.CREDITO);
    this.listaRegrasDebito = listaRegras.filter((regra: RegraInterface) => regra.tipoLancamento === TipoLancamentoEnum.DEBITO);
  }

  mounted() {
    this.buscarTodas();
  }
}
